<template>
  <div class="dashboard">
    <div class="container">
      <header class="dashboard__hero">
        <div class="dashboard__hero-brand">
          <div>
            <p class="dashboard__eyebrow">{{ $t("pages.dashboard.title") }}</p>
            <h1 class="dashboard__title" v-if="webUser">
              {{ $t("pages.dashboard.greeting") }}, {{ webUser }}
            </h1>
            <h1 class="dashboard__title" v-else>{{ $t("pages.dashboard.title") }}</h1>
          </div>
        </div>
        <div class="dashboard__date">
          <i class="far fa-calendar-alt" aria-hidden="true"></i>
          {{ todayLabel }}
        </div>
      </header>

      <section class="dashboard__section">
        <div class="dashboard__widgets">
          <responsible-pay-roll-for-sign-widget class="dashboard__widget" />
          <employee-working-widget class="dashboard__widget" />
          <employee-vacations-widget class="dashboard__widget" />
          <employee-sick-widget class="dashboard__widget" />
          <employee-resting-widget class="dashboard__widget" />
          <confirm-waiting-absence-widget class="dashboard__widget" />
        </div>
      </section>
    </div>

    <section class="dashboard__section">
      <div class="container">
        <div class="dashboard__section-head">
          <h2 class="dashboard__section-title">
            {{ $t("pages.dashboard.responsible.plan_employees") }}
          </h2>
        </div>
      </div>

      <div class="dashboard__panel plan dashboard__panel--bleed">
        <plan-component :defaultType="typeDayCalendar" />
      </div>
    </section>

    <work-shift-detail-modal />
  </div>
</template>

<script>
import ResponsiblePayRollForSignWidget from "@/pages/dashboard/widgets/ResponsiblePayRollForSignWidget.vue";
import { PlanComponent } from "@/pages/responsible/planing/general/components";
import { DATE_PERIOD_DAY } from "@/components/form";
import WorkShiftDetailModal from "@/pages/responsible/planing/workshift/components/WorkShiftDetailModal.vue";

import {
  EmployeeWorkingWidget,
  EmployeeRestingWidget,
  EmployeeVacationsWidget,
  EmployeeSickWidget,
} from "@/pages/responsible/planing/widgets";
import { ConfirmWaitingAbsenceWidget } from "@/pages/responsible/planing/absences/widgets";
import { mapGetters } from "vuex";

export default {
  components: {
    ResponsiblePayRollForSignWidget,
    EmployeeWorkingWidget,
    EmployeeRestingWidget,
    EmployeeVacationsWidget,
    EmployeeSickWidget,
    PlanComponent,
    ConfirmWaitingAbsenceWidget,
    WorkShiftDetailModal,
  },
  computed: {
    ...mapGetters("auth", ["webUser"]),
    typeDayCalendar() {
      return DATE_PERIOD_DAY;
    },
    todayLabel() {
      try {
        return new Date().toLocaleDateString(this.$i18n.locale.replace("_", "-"), {
          weekday: "long",
          day: "numeric",
          month: "long",
        });
      } catch (e) {
        return new Date().toLocaleDateString();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./dashboard-portal.scss";

::v-deep .dashboard__widget.custom-card {
  width: 100% !important;
  min-width: 0 !important;
}
</style>
